import { render, staticRenderFns } from "./DownTimeTable.vue?vue&type=template&id=32f9d232&scoped=true"
import script from "./DownTimeTable.vue?vue&type=script&lang=js"
export * from "./DownTimeTable.vue?vue&type=script&lang=js"
import style1 from "./DownTimeTable.vue?vue&type=style&index=1&id=32f9d232&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9d232",
  null
  
)

export default component.exports